import { useQuery } from '@apollo/client/react'

import { graphql } from '~publish/graphql'
import type { ResultOf } from '~publish/graphql'

// `channels` already scopes to the current user: it only returns channels the
// acting account holds any product access on, so no member filtering is
// needed client-side.
export const GetMyChannelPermissions = graphql(/* GraphQL */ `
  query GetMyChannelPermissions($input: ChannelsInput!) {
    channels(input: $input) {
      id
      name
      avatar
      service
      productAccessLevels {
        publish
        comments
      }
    }
  }
`)

type GetMyChannelPermissionsResult = ResultOf<typeof GetMyChannelPermissions>

export type ChannelWithProductAccess = NonNullable<
  GetMyChannelPermissionsResult['channels']
>[number]

interface UseMyChannelPermissionsReturn {
  channels: ChannelWithProductAccess[] | null
  loading: boolean
  error: boolean
}

export const useMyChannelPermissions = ({
  organizationId,
}: {
  organizationId?: string | null
}): UseMyChannelPermissionsReturn => {
  const { data, loading, error } = useQuery(GetMyChannelPermissions, {
    variables: {
      input: {
        organizationId: organizationId ?? '',
      },
    },
    skip: !organizationId,
  })

  return {
    channels: data?.channels ?? null,
    loading,
    error: !!error,
  }
}
